export default String.raw`
<div class="header-client-area__btn-wrapper mobile start">
    <a class="header-client-area__btn" href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}" rel="nofollow">
        <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
            <svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#home-{{settings.iconStyle}}"></use>
            </svg>
        </div>
        <div class="header-client-area__btn-text">{{ translations.Start }}</div>
    </a>
</div>

<button class="header-client-area__btn-wrapper mobile menu header-menu-js">
    <div class="header-client-area__btn">
        <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
            <svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bars-{{settings.iconStyle}}"></use>
            </svg>
        </div>
        <div class="header-client-area__btn-text">{{ translations.Menu }}</div>
    </div>
</button>

{% if usr.Authenticated or config.B2B and settings.inquiries == 'yes' -%}
    <div class="header-client-area__btn-wrapper mobile more select-wcag-js">
        <button class="header-more-js">
            <div class="header-client-area__btn">
                <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-h-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
                <div class="header-client-area__btn-text">{{ translations.More }}</div>
            </div>
        </button>

        <div class="header-client-area__more-dropdown header-more-dropdown-js dropdown-js"></div>
    </div>
{% endif -%}

{% if usr.Authenticated -%}
    <div class="header-client-area__btn-wrapper profile">
        {% if page.PageId != config.DefinedPages.CustomerProfile.Id or page.QueryString contains 'tab=wishlist' -%}
            <button class="header-client-area__btn header-profile-js">
        {% else -%}
            <a class="header-client-area__btn header-profile-js" {% if config.B2B -%} href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=eshop-orders" {% else -%} href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=active-orders" {% endif -%} rel="nofollow">
        {% endif -%}
                <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
                <div class="header-client-area__btn-text">{{ translations.ClientsProfile }}</div>
        {% if page.PageId != config.DefinedPages.CustomerProfile.Id or page.QueryString contains 'tab=wishlist' -%}
            </button>
        {% else -%}
            </a>
        {% endif -%}
    </div>

    <div class="header__sidebar hide none header-sidebar-js header-profile-sidebar-js">
        <div class="header__sidebar-content right hide header-sidebar-content-js header-profile">
            <div class="header__sidebar-header">
                <div class="header__sidebar-name">
                    <svg class="header__sidebar-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                    </svg>
					{{ translations.ClientsProfile }}
                </div>
                <button class="header__sidebar-closer header-sidebar-closer-js" aria-label="{{ translations.Close }}">
                    <svg aria-hidden="true">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </div>
            <div class="header-profile__content">
                <div class="header-profile__menu">
                    {% include 'partials/customer-profile/menu.html' -%}
                </div>
            </div>
        </div>
    </div>

    <div class="header-client-area__btn-wrapper wishlist wishlist-icon-container-js header-wishlist-btn-js">
        <a class="header-client-area__btn additional-option-js" {% if config.B2B -%} href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlists" {% else -%} href="{{ page.BaseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=wishlist" {% endif -%} rel="nofollow">
            <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}"></use>
                </svg>
                {% if customer.WishListCount > 0 and config.B2B == false -%}
                    <div class="wishlist-icon-js">
                        <span class="counter-bg">
                            <span class="wishlist-header-counter-js counter">
                                {{ customer.WishListCount }}
                            </span>
                        </span>
                    </div>
                {% endif -%}
            </div>
            <div class="header-client-area__btn-text">{{ translations.WishList }}</div>
        </a>
    </div>
{% else -%}
    <div class="header-client-area__btn-wrapper profile">
        {% assign pageLogin = true -%}
        {% if settings.signIn == "popup" and page.PageId != config.DefinedPages.Login.Id and page.PageId != config.DefinedPages.Registration.Id -%}
            {% assign pageLogin = false -%}
        {% endif -%}
        <a class="header-client-area__btn {% unless pageLogin -%} show-login-popup-js {% endunless -%}" {% if pageLogin -%} href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" {% endif -%}  rel="nofollow">
            <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{settings.iconStyle}}"></use>
                </svg>
            </div>
            <div class="header-client-area__btn-text">{{ translations.LogIn }}</div>
        </a>
    </div>
{% endif -%}

{% assign inquiryExists = false -%}
{% assign cartExists = false -%}
{% assign inquirySize = 0 -%}
{% assign cartSize = 0 -%}
{% for oneOfCart in customer.Carts -%}
    {% if oneOfCart.Inquiry -%}
        {% assign inquiryExists = true -%}
        {% assign inquirySize = inquirySize | Plus: 1 -%}
    {% else -%}
        {% assign cartExists = true -%}
        {% assign cartSize = cartSize | Plus: 1 -%}
    {% endif -%}
{% endfor -%}

{% if inquirySize == 0 and customer.Cart.Inquiry and customer.Cart.Products[0] -%}
    {% assign inquiryExists = true -%}
    {% assign inquirySize = inquirySize | Plus: 1 -%}
{% elsif cartSize == 0 and customer.Cart.Products[0] -%}
    {% assign cartExists = true -%}
    {% assign cartSize = cartSize | Plus: 1 -%}
{% endif -%}

{% assign inquiryActive = false -%}
{% if customer.Cart.Inquiry and config.B2B -%}
    {% assign inquiryActive = true -%}
{% endif -%}

{% if inquiryActive and page.PageId == config.DefinedPages.Order.Id -%}
    {% assign inquiryActiveOnCartPage = true -%}
{% endif -%}

{% if config.B2B and settings.inquiries == 'yes' -%}
    <div class="header-client-area__btn-wrapper inquiry header-inquiry-btn-js">
        <button class="additional-option-js header-client-area__btn {% unless page.PageId == config.DefinedPages.Order.Id and customer.Cart.Inquiry -%} header-inquiry-js {% if inquirySize == 1 -%} last-inquiry-js {% endif -%}{% endunless -%}">
            <div class="header-client-area__btn-icon-wrapper header-client-area__btn-icon">
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-invoice-dollar-{{settings.iconStyle}}"></use>
                </svg>
                <div>
                    <span class="counter-bg inquiry-counter-js hidden-js">
                        <span class="counter inquiry-count-to-replace-js"></span>
                    </span>
                </div>
            </div>
            <div class="header-client-area__btn-text">{{ translations.Inquiry }}</div>
        </button>

        {% if customer.Cart.Inquiry and include -%}
            {% include 'partials/common/header/inquiry-items-list.html' with include -%}
        {% endif -%}
    </div>
{% endif -%}

<div class="header-client-area__btn-wrapper cart">
    {% assign activeCartIndex = -1 -%}
    {% assign lastCartId = page.Cookies.lastCartId -%}
    {% for oneOfCart in customer.Carts -%}
        {% unless oneOfCart.Inquiry -%}
            {% if oneOfCart.Current -%}
                {% assign activeCartIndex = forloop.index0 -%}
            {% endif -%}
        {% endunless -%}
    {% endfor -%}
    <button class="header-client-area__btn header-cart-js" {% if page.PageId == config.DefinedPages.Order.Id -%} data-choice="goToCart" data-url="{{ page.BaseHref }}{{ config.DefinedPages.Order.Url }}" data-cart-id="{{activeCartIndex}}" {% endif -%}>
        {% if activeCartIndex == -1 and customer.Cart.Inquiry != true -%}
            {% assign newCartFlag = true -%}
        {% else -%}
            {% assign newCartFlag = false -%}
            {% if activeCartIndex == -1 -%}
                {% assign activeCartIndex = 0 -%}
                {% assign trueActiveCartIndex = -1 -%}
            {% endif -%}
            
        {% endif -%}
        <div class="header-client-area__btn-icon-wrapper">
            <div class="header-client-area__btn-icon cart-btn">
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#{{settings.cartIconStyle}}-{{settings.iconStyle}}"></use>
                </svg>
                
                {% unless newCartFlag -%}
                    {% assign currentCart = customer.Carts[activeCartIndex] -%}
                    <span class="counter-bg counter-bg-js {% unless currentCart.Count > 0 -%} hidden-js {% endunless -%}">
                        <span class="counter cart-count-js">
                            {{ currentCart.Count }}
                        </span>
                    </span>
                {% endunless -%}
            </div>

            <span class="header-client-area__btn-price">
                <span class="cart-value-js">
                    {% if inquiryActiveOnCartPage or page.QueryString contains 'empty-inquiry=true' -%}
                        {{ 0 | ToPrice }}
                    {% else -%}
                        {{ customer.Cart.Value | ToPrice }}
                    {% endif -%}
                </span>
                <span>{{customer.CurrencyExt}}</span>
            </span>

        </div>
        {% if newCartFlag -%}
            <div class="header-client-area__btn-text cart">{{translations.NewCart}}</div>
        {% else -%}
            <div class="header-client-area__btn-text cart current-cart-js" {% unless customer.Cart.EditedOrderId -%}data-cart-id="{{currentCart.Id}}" {% endunless -%}>
                {% if customer.Cart.EditedOrderId == null -%}
                    {{translations.Cart}}
                {% endif -%}
                <span class="small-cart-name-to-replace-js">{{currentCart.Name}}</span>
            </div>
            {% if trueActiveCartIndex == -1 -%}
                {% assign activeCartIndex = -1 -%}
            {% endif -%}
        {% endif -%}
        <div class="header-client-area__btn-text cart mobile">{{translations.Cart}}</div>
    </button>
    

    {% if page.PageId != config.DefinedPages.Order.Id or cart.CartEmpty or customer.Cart.Inquiry == false -%}
        {% if include -%}
            {% include 'partials/common/header/header-cart.html' with include -%}
        {% else -%}
            {% include 'partials/common/header/header-cart.html' -%}
        {% endif -%}
    {% endif -%}

    {% include 'partials/common/header/setting-cart.html' -%}
</div>

<script>
    if(typeof header != 'undefined' && typeof header.headerClientAreaInit == 'function') {
        header.headerClientAreaInit();
    }
</script>
`